export default __webpack_public_path__ + "static/media/iconmonstr-github-2.56951958.svg";